import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';

const VettingSection = () => {
  return (
    <Box id="vetting" sx={{ py: 6 }}>
      <Grid container spacing={4} alignItems={'center'}>
        <Grid item xs={12} md={8}>
          <Typography variant="h4" sx={{ fontWeight: 700 }} gutterBottom>
            Subcontractor Vetting for Construction Firms
          </Typography>
          <Typography variant="h6" color="text.secondary" paragraph>
            Reduce risk and accelerate project delivery with an external, tech-enabled
            subcontractor vetting system. Background checks, safety records, insurance
            verification, performance reviews, and capacity scoring — all in one place.
          </Typography>
          <Typography variant="body1" color="text.secondary">
            We integrate with your bid workflows to ensure only prequalified crews reach
            your estimators and PMs.
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Box display={'flex'} justifyContent={{ xs: 'flex-start', md: 'flex-end' }}>
            <Button
              variant="contained"
              color="primary"
              size="large"
              component="a"
              href="https://subs.skilledstrategies.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Visit Vetting Platform
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default VettingSection;


